
namespace GeniuzPOS.AdvPromo {

    @Serenity.Decorators.registerClass()
    export class PsAdvPromoHd1Grid extends Serenity.EntityGrid<PsAdvPromoHd1Row, any> {
        protected getColumnsKey() { return PsAdvPromoHd1Columns.columnsKey; }
        protected getDialogType() { return PsAdvPromoHd1Dialog; }
        protected getIdProperty() { return PsAdvPromoHd1Row.idProperty; }
        protected getInsertPermission() { return PsAdvPromoHd1Row.insertPermission; }
        protected getLocalTextPrefix() { return PsAdvPromoHd1Row.localTextPrefix; }
        protected getService() { return PsAdvPromoHd1Service.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getButtons() {
            var buttons = super.getButtons();

            // remove first button (Add button)
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            buttons.push(
                {
                    title: Q.text("Close"), // *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    onClick: () => {
                        window.location.href = '/';
                        return false;
                    },
                }
            );
            return buttons;

        }
    }
}